import * as React from "react";

import type { IconProps } from "./types";

export const CompassIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={forwardedRef}
    >
      <circle cx="8" cy="8" r="6.9" stroke={color} strokeWidth="1.2" />
      <path d="M8 2.9L10.1 8H5.9L8 2.9Z" fill={color} />
      <path d="M8 13.1L5.9 8H10.1L8 13.1Z" stroke={color} strokeWidth="0.9" strokeLinejoin="round" />
    </svg>
  ),
);

export default CompassIcon;
